import React from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const DeprecatedReviewModifyPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const reviewUrl = `/customer/orders/review/${id}/modify`;
    navigate(reviewUrl);
  }, []);

  return <React.Fragment />;
};
